import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/clickables/Button';

import cxHelpers from 'util/className';

@cxHelpers('EnableButtonInput')
export default class EnableButtonInput extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    enabledText: PropTypes.string,
    disabledText: PropTypes.string,
  };

  static defaultProps = {
    enabledText: 'Enabled',
    disabledText: 'Disabled',
  };

  handleClick = () => this.props.onChange(!this.props.value);

  render() {
    const { value, enabledText, disabledText, name } = this.props;

    return (
      <Button
        className={this.cx({ name })}
        iconColor={value ? 'white' : undefined}
        icon={value ? 'check' : undefined}
        color={value ? 'green' : undefined}
        onClick={this.handleClick}
      >
        {value ? enabledText : disabledText}
      </Button>
    );
  }
}
